/**
 * Salir del panel a otra dirección (el alta de Stripe, la página de pago de Stripe, un recibo, una descarga): siempre
 * una dirección que da la API (`onboarding_link.url`, `checkout_url`, `receipt_url`, `download_url`), nunca una
 * construida por el panel. Las pruebas cambian `abrir` para ver adónde se iría sin salir de la página.
 */
export const navegador = {
    /** Ir a la dirección en esta pestaña (el alta y el pago de Stripe vuelven solos al panel o a la página). */
    ir: (url: string): void => {
        window.location.assign(url);
    },
    /** Abrirla en otra pestaña (recibos y descargas). */
    abrir: (url: string): void => {
        window.open(url, '_blank', 'noopener');
    },
};
